import './FavorButton.less';
import React, {useState, useEffect, useContext} from 'react';
import Icon from "../../../../bootstrap/components/icon/Icon";
import Request from "../../../../bootstrap/api/Request";
import LibraryFavoritesParcel from "../../../api/endpoints/library/LibraryFavoritesParcel";
import AuthContext from "../../../contexts/auth/AuthContext";
import LibraryFavorParcel from "../../../api/endpoints/library/LibraryFavorParcel";
import Toasts, {TOAST_ERROR} from "../../../../bootstrap/scomponents/toasts/Toasts";
import LibraryUnfavorParcel from "../../../api/endpoints/library/LibraryUnfavorParcel";
import __ from "../../../i18n";
import HistoryContext from "../../../contexts/history/HistoryContext";
import {useHistory} from 'react-router-dom';
import routes from "../../../routing/routes";


export default function FavorButton({course}) {

    const {user} = useContext(AuthContext);

    const history = useHistory();

    const historyContext = useContext(HistoryContext);

    const [isFavorite, setIsFavorite] = useState(null);

    const fetchFavoriteInfo = () => {
        if (user === null) {
            return;
        }

        Request.add(new LibraryFavoritesParcel({
            filters: [{field: 'course_id', operator: '=', value: course.id}],
            filtersConfig: {course_id: {type: 'number'}},
            limit: 1
        }))
            .then(data => {
                setIsFavorite(data.total > 0);
            })
            .catch(error => {
                console.log(error);
                setIsFavorite(false);
            });
    };

    useEffect(() => {
        if (user === null) {
            setIsFavorite(null);
            return;
        }

        fetchFavoriteInfo();
    }, [user]);

    const requestFavor = () => {
        if (user === null || isFavorite !== false) {
            return;
        }

        setIsFavorite(true);

        Request.add(new LibraryFavorParcel(course.id))
            .catch(error => {
                setIsFavorite(false);
                Toasts.add(TOAST_ERROR, error.getMessage());
            });
    };

    const requestUnfavor = () => {
        if (user === null || isFavorite !== true) {
            return;
        }

        setIsFavorite(false);

        Request.add(new LibraryUnfavorParcel(course.id))
            .catch(error => {
                setIsFavorite(true);
                Toasts.add(TOAST_ERROR, error.getMessage());
            });
    };

    const redirectLogin = () => {
        if (user !== null) {
            return;
        }

        historyContext.setLoginReferer(history.location);
        history.push(routes.login.getUrl());
    };

    const getTitle = () => {
        if (user === null) {
            return __('Please login to like');
        }

        if (isFavorite === true) {
            return __('You liked this course');
        }

        if (isFavorite === false) {
            return __('Like this course');
        }

        return undefined;
    }

    const handleClick = () => {
        if (user === null) {
            return redirectLogin();
        }

        if (isFavorite === true) {
            return requestUnfavor();
        }

        if (isFavorite === false) {
            return requestFavor();
        }
    }

    return <button
        className="favor-button"
        type="button"
        disabled={user !== null && isFavorite === null}
        onClick={() => handleClick()}
        aria-label={getTitle()}
    >
        {
            isFavorite === true
                ? <Icon name="heart-solid"/>
                : <Icon name="heart-outline"/>
        }
    </button>;
}
